import React, { useEffect } from 'react';

import { Button, Typography } from '@mui/material';
import * as MATERIEL_ICONS from '@mui/icons-material/';
import Autocomplete from '@mui/material/Autocomplete';
import { TextField } from '@mui/material';
import { Select } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

import { product_fields } from '../constants/create_product_fields';
import CustomInput from '../../../../components/CustomInput';
import service from '../service';
import { toast } from 'react-toastify';
import { useBoundStore } from '../../../../stores';
import { useNavigate } from 'react-router-dom';

function CreateProductDrawer() {

  const toggleRightDrawer = useBoundStore((state) => state.toggleRightDrawer);
  const [valid, setValid] = React.useState(false);
  const navigate = useNavigate()

  const [productFormData, setProductFormData] = React.useState({
    productName: '',
    productType: '',
    barcodeNumber: '',
    description: '',
    status: 'ACTIVE',
  });

  const validateForm = () => {
    if (
      productFormData.productName
      // productFormData.barcodeNumber &&
      // productFormData.status
    ) {
      setValid(true);
    } else {
      setValid(false);
    }
  };

  const handleSave = async () => {
    // console.log(productFormData);
    await service.saveProduct(productFormData).then((response) => {
      if (response?.status === 200 || response?.status === 201) {
        toast.success('Ürün başarıyla oluşturuldu.');
      } else {
        toast.error('Ürün oluşturulurken hata oluştu.');
      }
      navigate('/definitions/products');
      toggleRightDrawer();
    });
  };

  useEffect(() => {
    validateForm();
  }, [productFormData]);

  // useEffect(() => {
  //   getData();
  // }, []);

  return (
    <div className="mt-5">
      <div className="px-2">
        <Typography variant="h6">Ürün Ekle</Typography>
      </div>
      <div>
        <>
          <div>
            <div className="flex flex-row flex-wrap justify-center items-center gap-4 w-full my-5">
              {product_fields().map((field, index) => {
                return (
                  <div className=" flex w-full" key={index}>
                    <CustomInput
                      key={index}
                      type={field.type}
                      inputType={field.inputType}
                      defaultValue={field.defaultValue}
                      items={field.items}
                      label={field.placeHolder}
                      value={productFormData[field.key]}
                      fullWidth={true}
                      size={'small'}
                      onChange={(key, value) => {
                        setProductFormData({
                          ...productFormData,
                          [field.key]: value,
                        });
                      }}
                    />
                  </div>
                );
              })}
              <Button
                disabled={!valid}
                variant="contained"
                color="primary"
                startIcon={<MATERIEL_ICONS.Save />}
                onClick={() => handleSave()}
                className="mx-2"
              >
                Kaydet
              </Button>
            </div>
          </div>
        </>

      </div>
    </div>
  );
}

export default CreateProductDrawer;
